import api from './axiosInstance';
import { OrganizationInfo } from '../utils/planConfig';

export interface RegisterPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  workspaceName?: string;
  includeSampleData?: boolean;
  acceptedTerms?: boolean;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AuthResponse {
  message: string;
  user?: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: 'admin' | 'editor' | 'viewer';
    organizationId: string;
  };
  organization?: OrganizationInfo;
  token?: string;
}

export const register = async (payload: RegisterPayload): Promise<AuthResponse> => {
  const { data } = await api.post<AuthResponse>(`/auth/register`, payload);
  return data;
};

export const login = async (payload: LoginPayload): Promise<AuthResponse> => {
  const { data } = await api.post<AuthResponse>(`/auth/login`, payload);
  return data;
};

export const updateOrganization = async (name: string): Promise<OrganizationInfo> => {
  const { data } = await api.patch<OrganizationInfo>('/auth/organization', { name });
  return data;
};
